import React, { useState, useEffect, useContext } from 'react';
import { PatrimonioContext } from '../../../contexts/patrimonioProvider';
import { UserContext } from '../../../contexts/userProvider';
import DataTable from '../../Table';
import Loader from '../../Loader/load';

const Estoque = () => {
  const { getEstoquePorCliente } = useContext(PatrimonioContext);
  const { setAlert } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const [estoqueData, setEstoqueData] = useState([]);

  useEffect(() => {
    loadEstoque();
  }, []);

  const loadEstoque = async () => {
    setLoading(true);
    try {
      const dados = await getEstoquePorCliente();
      setEstoqueData(dados);
    } catch (error) {
      console.error(error);
      setAlert({
        visible: true,
        title: "Erro!",
        placeholder: "Erro ao carregar dados de estoque",
        confirm: false,
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const headers = [
    {
      label: 'Cliente',
      key: 'nome_cliente',
      sortable: true,
      width: 'w-3/4',
    },
    {
      label: 'Total de Patrimônios',
      key: 'total_patrimonios',
      sortable: true,
      width: 'w-1/4',
      render: (item) => (
        <span className="px-3 py-1 rounded-full text-sm font-semibold bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300">
          {item.total_patrimonios}
        </span>
      ),
    },
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="estoque-container">
          {estoqueData && estoqueData.length > 0 ? (
            <DataTable
              data={estoqueData}
              headers={headers}
              itemsPerPage={15}
              exportButton={true}
              docTitle="Relatório de Estoque por Cliente"
            />
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-center">
              <div className="text-gray-400 mb-4">
                <svg className="w-16 h-16 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Nenhum patrimônio em estoque
              </h3>
              <p className="text-gray-500 dark:text-gray-400 max-w-sm">
                Não há patrimônios cadastrados em anexos de estoque.
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Estoque;
